import React from 'react';
import '../../css/components/ProfileSidebar.css';
import { useUser } from '../../firebase_service/UserContext';
import { signOut } from "firebase/auth";
import { useNavigate } from 'react-router-dom';
import { doc, setDoc, getDoc, Timestamp } from "firebase/firestore";
import { auth, provider, db } from "../../firebase_service/firebase";

const ProfileSidebar = ({ open, onClose }) => {
  const { user, loading, logout } = useUser();
  const navigate = useNavigate();

  const handleSignInClick = () => {
    navigate('/webpagelogin');
    onClose(); // Close the sidebar after navigating
  };
  return (
    <div className={`profile-sidebar${open ? ' open' : ''}`}>
      <div className="profile-sidebar-header">
        <button className="close-btn" onClick={onClose} aria-label="Close">&times;</button>
        <h1 className='profile_text'>Profile</h1>
      </div>
      <div className="profile-sidebar-content">
        <div className="profile-avatar">
          {user && user.photoURL ? (
            <img src={user.photoURL} alt="avatar" style={{ borderRadius: '50%', width: 64, height: 64 }} />
          ) : (
            <svg width="64" height="64" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="16" cy="16" r="16" fill="#fff"/>
              <circle cx="16" cy="13" r="5" fill="#e74c3c"/>
              <ellipse cx="16" cy="23" rx="7" ry="4" fill="#e74c3c"/>
            </svg>
          )}
        </div>
        <div className="profile-info">
          {loading ? (
            <p>Loading...</p>
          ) : user ? (
            <>
              <h3>{user.displayName}</h3>
              <p>{user.email}</p>
            </>
          ) : (
            <p>Not signed in</p>
          )}
        </div>
        <ul className="profile-actions">
          {user ? (
            <>
              <li><a href="dashboard">Dashboard</a></li>
              
              <li><button onClick={logout} className="btn btn-secondary" style={{ width: '100%' }}>Logout</button></li>
            </>
          ) : (
            <li><button onClick={handleSignInClick} className="btn btn-primary" style={{ width: '100%' }}>Sign in with Google</button></li>
          )}
        </ul>
      </div>
    </div>
  );
};

export default ProfileSidebar;